module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-5_BW-c3fa86541e6bf6527a6b1a8c6d34005a.jpg";